import RecuperarContraseña from './RecuperarContraseña';
export default RecuperarContraseña;